if (!window.Maximize.loadedScript.includes("recently-viewed.js")) {
  window.Maximize.loadedScript.push("recently-viewed.js");

  requestAnimationFrame(() => {
    const defineXProductRecently = () => {
      Alpine.store("xProductRecently", {
        show: false,
        loading: true,
        productsToShow: 0,
        productsToShowMax: 10,
        listRecentlyProducts: [],
        init() {
          const recentlyProductsStored = localStorage.getItem("recently-viewed") || "[]";
          try {
            const parsed = JSON.parse(recentlyProductsStored);
            this.listRecentlyProducts = Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            this.listRecentlyProducts = [];
          }
          this.readLimit();
        },
        readLimit() {
          const section = document.getElementById("RecentlyViewedSection");
          const fromSection = section ? Number(section.dataset.productsToShow) : 0;
          const limit = Number(this.productsToShow) || fromSection || 4;
          this.productsToShow = limit;
          return limit;
        },
        visibleProducts(productId) {
          const current = productId ? String(productId) : "";
          const limit = this.readLimit();
          return (this.listRecentlyProducts || [])
            .map((id) => String(id))
            .filter((id) => id && id !== "null" && id !== "undefined" && id !== current)
            .slice(0, limit);
        },
        showProductRecently(productId) {
          this.show = this.visibleProducts(productId).length > 0;
        },
        setProduct(productViewed) {
          const id = String(productViewed || "");
          if (!id) return;
          const kept = (this.listRecentlyProducts || [])
            .map((item) => String(item))
            .filter((item) => item && item !== id)
            .slice(0, this.productsToShowMax - 1);
          this.listRecentlyProducts = [id, ...kept];
          localStorage.setItem("recently-viewed", JSON.stringify(this.listRecentlyProducts));
          const section = document.getElementById("RecentlyViewedSection");
          const currentId = section ? section.dataset.currentProduct : "";
          this.show = this.visibleProducts(currentId).length > 0;
        },
        placeCards(root, products) {
          const container = root.querySelector(".slider-container");
          if (!container) return 0;
          const order = products.map((id) => String(id));
          Array.from(container.querySelectorAll("[data-product-id]")).forEach((card) => {
            if (!order.includes(String(card.dataset.productId))) card.remove();
          });
          container.querySelectorAll(".skeleton-product-card").forEach((node) => node.remove());
          order.forEach((id) => {
            const card = container.querySelector('[data-product-id="' + id + '"]');
            if (card) container.appendChild(card);
          });
          return container.querySelectorAll("[data-product-id]").length;
        },
        getProductRecently(sectionId, productId) {
          const products = this.visibleProducts(productId);
          const el = document.querySelector("#RecentlyViewedSection .recently-viewed__content");
          if (!products.length || !el) {
            this.show = false;
            this.loading = false;
            return;
          }
          this.show = true;
          const query = products.map((value) => "id:" + value).join(" OR ");
          const searchUrl = `${Shopify.routes.root}search?section_id=${sectionId}&type=product&q=${encodeURIComponent(query)}`;
          fetch(searchUrl)
            .then((response) => {
              if (!response.ok) return null;
              return response.text();
            })
            .then((text) => {
              if (!text || !el.isConnected) return;
              const parsed = new DOMParser().parseFromString(text, "text/html");
              const resultsElement = parsed.querySelector("#RecentlyViewedSection .recently-viewed__content");
              if (!resultsElement) {
                this.show = false;
                return;
              }
              el.innerHTML = resultsElement.innerHTML;
              if (!this.placeCards(el, products)) this.show = false;
              document.dispatchEvent(new CustomEvent(`${ANIMATION_EVENT.revealItem}`));
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false;
            });
        },
        clearHistory() {
          localStorage.removeItem("recently-viewed");
          this.listRecentlyProducts = [];
          this.show = false;
        },
      });
    };
    if (window.Alpine) {
      defineXProductRecently();
    } else {
      document.addEventListener("alpine:init", defineXProductRecently);
    }
  });
}
